import { getDatabase, push, ref } from "firebase/database";

export function generateMessageId() {
  return push(ref(getDatabase(), "messages")).key;
}
